import { createClient } from 'contentful'
import { getEnv } from 'lib/envWrapper'
import { ContentfulLogger } from 'services/Logger'

const env = getEnv()
const client = createClient({
	space: env.contentful.space,
	accessToken: env.contentful.token,
	logHandler: (level, data) => {
		ContentfulLogger.log(`Contentful ${level}`, data)
	},
	retryLimit: 2
})

export const fetchEntries = client.getEntries
export const fetchEntry = client.getEntry
